<script setup>
import { ref, computed } from 'vue'
import { useNewsStore } from '@stores/news'
import PulsingSubtitle from '@components/global/PulsingSubtitle.vue'
import NewsCard from '@components/news/NewsCard.vue'
import Button from '@components/forms/Button.vue'

defineProps(['data'])

const news = useNewsStore()

const limit = ref(3)

const latestNews = computed(() => {
	return news.articles.slice(0, limit.value)
})
</script>

<template>
	<section class="py-10 md:py-20" v-if="news.articles?.length > 0">
		<div class="container">
			<div class="flex flex-col gap-8 md:gap-14">
				<div v-if="data.eyebrow || data.title" class="flex flex-col items-start gap-6 md:w-2/3 md:gap-8">
					<PulsingSubtitle v-if="data.eyebrow">{{ data.eyebrow }}</PulsingSubtitle>
					<h2 v-if="data.title">{{ data.title }}</h2>
				</div>
				<div class="flex flex-col gap-4">
					<NewsCard v-for="article in latestNews" :key="article.slug" :article="article" />
				</div>
				<div class="flex justify-center">
					<Button class="primary solid" v-if="news.articles.length > limit" @click="limit += 3">View More</Button>
				</div>
			</div>
		</div>
	</section>
</template>
